module.exports = __webpack_public_path__ + "img/noip.216df63a.jpg";